'use client'
import { useDevice } from '@lune-fe/lune-ui-lib'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import Image from 'next/image'
import { FC } from 'react'

import Profile from '@/components/Profile'
import { formatDate } from '@/utills'

interface BlogHeaderProps {
    title: string
    subtitle?: string | null
    date: string | Date
    author: {
        name: string
        title: string
        avatar: string
    }
}

export const BlogHeader: FC<BlogHeaderProps> = ({ title, subtitle, date, author }) => {
    const { xsScreen } = useDevice()
    const titleSx = {
        wordBreak: `break-word`,
        whiteSpace: `pre-wrap`,
        wordWrap: `break-word`,
        textAlign: {
            xs: 'left',
            sm: 'center',
            md: 'center',
            lg: 'center',
            xl: 'center',
        },
    }

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems={xsScreen ? 'flex-start' : 'center'}
            spacing={{
                xs: 3,
                sm: 4,
                md: 4,
                lg: 4,
                xl: 4,
            }}
            sx={{
                mx: { xs: 0, sm: 0, md: 0, lg: 20, xl: 20 },
                pt: {
                    xs: `40px !important`,
                    sm: `40px !important`,
                    md: `72px !important`,
                    lg: `72px !important`,
                    xl: `72px !important`,
                },
            }}
        >
            <Profile
                name={author.name}
                title={author.title}
                avatar={<Image src={author.avatar} width={800} height={80} alt={author.name} />}
            />

            <Text variant={xsScreen ? `h4` : `h2`} component="div" sx={titleSx}>
                {title}
            </Text>

            {subtitle && (
                <Text
                    color={'Grey900'}
                    variant={'body1'}
                    component="span"
                    textAlign={xsScreen ? 'left' : 'center'}
                >
                    {subtitle}
                </Text>
            )}

            <Text color={'Grey900'} variant={'body1'} component="span">
                {formatDate(new Date(date))}
            </Text>
        </Stack>
    )
}
